import { gql } from "@apollo/client";

export const LOAD_VIEWER = gql`
  query LoadViewer($metricMrns: [String!]) {
    viewer {
      mrn
      email
      name
      createdAt
      state
      organizations {
        id
        mrn
        name
        company
        description
        capabilities
        spacesCount
        subscriptionInfo {
          basePlan {
            name
            id
          }
        }
        memberStats {
          total
          owners {
            mrn
            name
            ... on User {
              email
            }
          }
        }
        metrics(metricMrns: $metricMrns) {
          ... on MetricsResponse {
            entries {
              metricMrn
              title
              arrowResult
            }
          }
        }
      }
      firstSpace {
        id
        mrn
        name
        description
        priorityFindings
        organization {
          id
          mrn
          name
          description
        }
        settings {
          eolAssetsConfiguration {
            enable
            monthsInAdvance
          }
          garbageCollectAssetsConfiguration {
            enable
            afterDays
          }
          terminatedAssetsConfiguration {
            cleanup
            after
          }
          unusedServiceAccountsConfiguration {
            cleanup
            after
          }
          platformVulnerabilityConfiguration {
            enable
          }
          casesConfiguration {
            autoCreate
            aggregationWindow
          }
          platformMqlVexConfiguration {
            enable
          }
          mvdExperimentalSourcesConfiguration {
            sources {
              id
              name
              enabled
            }
          }
        }
        assetGroupStats {
          listsAssetTypes {
            assetType
            aliases
            displayName
            shortName
          }
          groupType
          displayName
          icon
          count
          statistics {
            type {
              assetType
              aliases
              displayName
              shortName
            }
            count
          }
        }
        stats {
          assetGroupStatistics {
            groupType
            count
          }
        }
      }
    }
    viewerSettings {
      key
      value
    }
  }
`;
